// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__YdBAO","footerLink":"footer_footerLink__fg+Yh","footerIcon":"footer_footerIcon__KCH-B"};